import React, { useEffect, useState, useRef } from 'react'
import { dataLabelText } from './ContentClass'

import { IoShareOutline } from 'react-icons/io5' // https://react-icons.github.io/react-icons/icons?name=io5
import { FacebookShareButton, FacebookIcon, HatenaShareButton,  HatenaIcon, TwitterShareButton, TwitterIcon } from "react-share"
import { isMobile, isTablet, isDesktop } from 'react-device-detect'

let label = ''

export const replaceDateToString = function(date) {
    const year_str = date.getFullYear()
    const month_str = 1 + date.getMonth()
    const day_str = date.getDate()
    const hour_str = date.getHours()
    const minute_str = date.getMinutes()
    const second_str = date.getSeconds()
    
    let format_str = 'YYYY年MM月DD日'
    format_str = format_str.replace(/YYYY/g, year_str)
    format_str = format_str.replace(/MM/g, month_str)
    format_str = format_str.replace(/DD/g, day_str)
    format_str = format_str.replace(/hh/g, hour_str)
    format_str = format_str.replace(/mm/g, minute_str)
    format_str = format_str.replace(/ss/g, second_str)
    
    return format_str
}

export const ContentsView =(props) => {

    const {options, viewMarkerOnMap, onChange} = props

    const toggleSharePanel = (e) => {
        // DOM操作によるON /OFF
        const shareModal = e.target.parentNode.parentNode.querySelector('.modal')
        if (Array.prototype.find.call(shareModal.classList, (el) => el === 'inactive') === 'inactive') {
            shareModal.className = shareModal.className.replace(/inactive/, 'active')
        } else {
            shareModal.className = shareModal.className.replace(/active/, 'inactive')
        }
    }

    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                const datas = Array.prototype.slice.call(document.getElementsByClassName('contentsView'))
                const idx = datas.findIndex((n) => n.dataset.id === entry.target.dataset.id);
                if (entry.isIntersecting) {
                   viewMarkerOnMap(entry.target.dataset.id)
                   onChange(idx+1)
                }
            }, { 
                rootMargin:'-50% 0px', 
                threshold: [0]
            },
        );
      
        if (ref.current === null) return;
        observer.observe(ref.current);
        const { current } = ref;
        return () => {
            observer.unobserve(current);
        };
    }, []);

    const c = options
    let relatedInfoLabel1 = ''
    let relatedInfoLabel2 = ''
    let relatedInfoLabel3 = ''

    const shareUrl = `${window.location.href}?cid=${options.uid}`

    const isImage = (c.imageUrl !== '') ? true : false
    label = dataLabelText

    const parser = new DOMParser()
    const root = parser.parseFromString(c.copy, 'text/html')
    const copyText = root.body.textContent || ''

    const d = Object.keys(c).map((key, idx) => {
        if (key === 'relatedInfoLabel1' && c[key] !== '') {
            relatedInfoLabel1 = c[key]
        } else if (key === 'relatedInfoLabel2' && c[key] !== '') {
            relatedInfoLabel2 = c[key]
        } else if (key === 'relatedInfoLabel3' && c[key] !== '') {
            relatedInfoLabel3 = c[key]
        } else if (key === 'relatedInfoUrl1' && c[key] !== '') {
            // relatedInfo[0] = {'label':relatedInfoLabel1, 'url':c[key]}
            return <tr className={`relatedInfoUrl ${key}`} key={idx}><td className="label"><span>参考情報</span></td><td className="data"><a href={`${c[key]}`} target='_blank'>{relatedInfoLabel1}</a></td></tr>
        } else if (key === 'relatedInfoUrl2' && c[key] !== '') {
            // relatedInfo[1] = {'label':relatedInfoLabel2, 'url':c[key]}
            return <tr className={`relatedInfoUrl ${key}`} key={idx}><td className="label"><span>参考情報</span></td><td className="data"><a href={`${c[key]}`} target='_blank'>{relatedInfoLabel2}</a></td></tr>
        } else if (key === 'relatedInfoUrl3' && c[key] !== '') {
            // relatedInfo[2] = {'label':relatedInfoLabel3, 'url':c[key]}
            return <tr className={`relatedInfoUrl ${key}`} key={idx}><td className="label"><span>参考情報</span></td><td className="data"><a href={`${c[key]}`} target='_blank'>{relatedInfoLabel3}</a></td></tr>
        } else if (typeof c[key] === 'string' && c[key] !== '') {
            c[key] = c[key].replace(/\n/g,'<br>')
            return <tr className={`${key}`} key={idx}><td className="label">{decodeURI(label[key])}</td><td className="data"><span dangerouslySetInnerHTML={{__html: c[key]}} /></td></tr>
        } else if (key === 'genre' && c[key][0] !== '') {
            const genre = c[key].join('、')
            return <tr className={`${key}`} key={idx}><td className="label">{decodeURI(label[key])}</td><td className="data">{genre}</td></tr>
        } else if (key === 'contactUrl' && typeof c[key] === 'object') {
            return <tr className={`${key}`} key={idx}><td className="label">{decodeURI(label[key])}</td><td className="data"><a href={`${c[key].href}`} target='_blank'>{c[key].href}</a></td></tr>
        }
        return // continueの代替処理
    }).filter(key => key)

    return (
        <div className="contentsView" data-id={c.uid} ref={ref} >
            <section className="header">
                <time>登録日：{replaceDateToString(c.publishedDate)}</time>
                <h2 dangerouslySetInnerHTML={{__html: c.copy}} />
                <span>{c.mainOrg}</span>
                <div className="share">
                    <a onClick={(e) => toggleSharePanel(e)}><IoShareOutline /></a>
                    <figure className="modal inactive">
                        <TwitterShareButton url={shareUrl} title={`5G/ローカル5G事例マップ：${copyText}`}>
                            <TwitterIcon size={32} bgStyle={{'fill':'black'}} iconFillColor={`white`} round />
                        </TwitterShareButton>
                        <FacebookShareButton url={shareUrl}>
                            <FacebookIcon size={32} bgStyle={{'fill':'black'}} iconFillColor={`white`} round />
                        </FacebookShareButton>
                        <HatenaShareButton url={shareUrl} title={`5G/ローカル5G事例マップ：${c.copy}`}>
                            <HatenaIcon size={32} bgStyle={{'fill':'black'}} iconFillColor={`white`} round />
                        </HatenaShareButton>
                    </figure>
                </div>
            </section>
            {isImage && (
                <figure className="image"><img src={c.imageUrl} alt={c.theme} loading="lazy" /></figure>
            )}
            <section className="detail">
                <table>
                <tbody>{d}</tbody>
                </table>
            </section>
        </div>
    )
}